import './index.css';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useCallback } from 'react';
import { InfoDayPicker } from './DayPicker.js';
import { Header } from './Header.js';
import { MonthPicker } from './MonthPicker.js';
import { Weekdays } from './Weekdays.js';
import { YearPicker } from './YearPicker.js';
import { useDatePickerControls } from './useDatePickerControls.js';
import { useDisplayDate } from './utils.js';
import { Divider } from '@hh.ru/magritte-ui-divider';
import { s as styles } from './date-picker-PHuacXwG.js';
import 'classnames';
import 'date-fns';
import 'date-fns/constants';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-action';
import '@hh.ru/magritte-ui-bottom-sheet';
import './useDisabledDatesFunc.js';
import './AsyncDataContext.js';
import './useIntervalPicker.js';
import '@hh.ru/magritte-ui-icon/icon';
import '@hh.ru/magritte-ui-navigation-bar';
import '@hh.ru/magritte-ui-spacing';
import '@hh.ru/magritte-ui-tooltip';
import '@hh.ru/magritte-ui-typography';

const InfoDatePicker = ({ 
// настройки функциональности
displayDate: _displayDate, enabledCalendars, holidays, shortWorkdays, 
// колбеки
onDisplayDateChange, 
// настройки внешнего вида
activeHeader, alignHeader, headerMonthFormat, locale, showControls, showDivider = true, showHeader = true, showHeaderDate, showWeekdays = true, }) => {
    const displayDate = useDisplayDate(_displayDate);
    const { calendar, switchCalendar, zoomIntoMonth, zoomIntoYear, goToNextPeriod, goToPrevPeriod } = useDatePickerControls(enabledCalendars, displayDate, onDisplayDateChange);
    return (jsx("div", { className: styles.layout, children: jsxs("div", { className: styles.datePicker, "data-qa": "date-picker", children: [showHeader && (jsx(Header, { calendar: calendar, displayDate: displayDate, activeHeader: activeHeader, alignHeader: alignHeader, goToNextPeriod: goToNextPeriod, goToPrevPeriod: goToPrevPeriod, headerMonthFormat: headerMonthFormat, locale: locale, showControls: showControls, showHeaderDate: showHeaderDate, switchCalendar: switchCalendar })), showWeekdays && calendar === 'day' && jsx(Weekdays, { locale: locale }), showDivider && (showHeader || showWeekdays) && jsx(Divider, {}), calendar === 'day' && (jsx(InfoDayPicker, { displayDate: displayDate, holidays: holidays, shortWorkdays: shortWorkdays })), calendar === 'month' && (jsx(MonthPicker, { locale: locale, displayDate: displayDate, onDateSelect: zoomIntoMonth })), calendar === 'year' && jsx(YearPicker, { displayDate: displayDate, onDateSelect: zoomIntoYear })] }) }));
};
const UncontrolledInfoDatePicker = ({ displayDate: initialDisplayDate, onDisplayDateChange, ...props }) => {
    const [displayDate, setDisplayDate] = useState(useDisplayDate(initialDisplayDate));
    const handleDisplayDateChange = useCallback((value) => {
        onDisplayDateChange?.(value);
        setDisplayDate(value);
    }, [onDisplayDateChange, setDisplayDate]);
    return jsx(InfoDatePicker, { ...props, displayDate: displayDate, onDisplayDateChange: handleDisplayDateChange });
};

export { InfoDatePicker, UncontrolledInfoDatePicker };
//# sourceMappingURL=InfoDatePicker.js.map
